"use strict";

var _regeneratorRuntime = require("/Users/jonathanallenberg/projects/boxtronik/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Client = void 0;

var loglevel_1 = __importDefault(require("loglevel"));

var users_pb_1 = require("@textile/users-grpc/users_pb");

var users_pb_service_1 = require("@textile/users-grpc/users_pb_service");

var threads_client_1 = require("@textile/threads-client");

Object.defineProperty(exports, "Client", {
  enumerable: true,
  get: function get() {
    return threads_client_1.Client;
  }
});

var threads_id_1 = require("@textile/threads-id");

var logger = loglevel_1.default.getLogger('users');

threads_client_1.Client.prototype.getThread = function (name, ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _this = this;

    var client;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            logger.debug('get thread request');
            client = new users_pb_service_1.APIServiceClient(this.serviceHost, {
              transport: this.rpcOptions.transport,
              debug: this.rpcOptions.debug
            });
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              var req = new users_pb_1.GetThreadRequest();
              req.setName(name);

              _this.context.toMetadata(ctx).then(function (meta) {
                client.getThread(req, meta, function (err, message) {
                  if (err) reject(err);
                  var msg = message === null || message === void 0 ? void 0 : message.toObject();

                  if (msg) {
                    msg.id = threads_id_1.ThreadID.fromBytes(Buffer.from(msg.id, 'base64')).toString();
                  }

                  resolve(msg);
                });
              }).catch(function (err) {
                reject(err);
              });
            }));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
};
/**
 * Returns a list of available Threads.
 * @param ctx Context containing gRPC headers and settings.
 * These will be merged with any internal credentials.
 * @note Threads can be created using the threads or threads network clients.
 */


threads_client_1.Client.prototype.listThreads = function (ctx) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var _this2 = this;

    var client;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            logger.debug('list threads request');
            client = new users_pb_service_1.APIServiceClient(this.serviceHost, {
              transport: this.rpcOptions.transport,
              debug: this.rpcOptions.debug
            });
            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              var req = new users_pb_1.ListThreadsRequest();

              _this2.context.toMetadata(ctx).then(function (meta) {
                client.listThreads(req, meta, function (err, message) {
                  if (err) reject(err);
                  var msg = message === null || message === void 0 ? void 0 : message.toObject();

                  if (msg) {
                    msg.listList.forEach(function (thread) {
                      thread.id = threads_id_1.ThreadID.fromBytes(Buffer.from(thread.id, 'base64')).toString();
                    });
                  }

                  resolve(msg);
                });
              }).catch(function (err) {
                reject(err);
              });
            }));

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));
};